import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

import { API_URL } from "./token.service";

import "rxjs/add/operator/filter";

@Injectable()
export class _OrganizationService {
  constructor(private http: HttpClient) {}

  getOrganization() {
    return this.http.get(`${API_URL}/organizations/0`);
  }

  getOrganizationList() {
    return this.http.get(`${API_URL}/organizations`).toPromise();
  }

  getOrganizationListForAdmin() {
    return this.http.get(`${API_URL}/organizations/for-admin`).toPromise();
  }

  createOrganization(data) {
    return this.http.post(`${API_URL}/organization`, data);
  }

  updateOrganization(id: number, data) {
    return this.http.put(`${API_URL}/organizations/${id}`, data);
  }

  deleteOrganization(id: number) {
    return this.http.delete(`${API_URL}/organizations/${id}`);
  }
}



// WEBPACK FOOTER //
// /app/wiserisk-core/src/main/ng4app/src/app/services/organization.service.ts